/* eslint-disable */
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { getCategories as getHistoryCategories } from "~/util/providers/history";
import { CONFIG } from "~/config";
import { ICategoryItem } from "~/interfaces";

interface IResponse {
	items: Array<ICategoryItem>;
}

let categories = CONFIG.userHistory?.category?.length ? Promise.resolve(CONFIG.userHistory?.category) : loadCategories();

const w = watch(store.getState, "user", watchCurrentUser);
store.subscribe(w(() => {
	categories = loadCategories();
}));

export function getCategories() {
	return categories.then(data => {
		if (!data.length) {
			categories = loadCategories();
		}

		return categories;
	}, () => {});
}

async function loadCategories(): Promise<Array<ICategoryItem>> {
	try {
		const response = await getHistoryCategories();
		const cat = await response.json() as IResponse;

		return cat.items || [];
	} catch (ex) {

		const module = await import(
			/* webpackChunkName: "fixed-categories" */
			"~/search/fixedsuggest/fixed-categories"
		);

		return module.FIXED_CATEGORIES[["cs", "sk"].indexOf(CONFIG.defaultLang) > -1 ? "cs" : "en"];
	}
}
